import { TagManager } from '@navent-jobs/config'

export const SignInDataLayers = {
  loginExitoso: (id, method, origin) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'login_empresas',
        user_id_custom: `${id}`,
        method: `${method}`,
        user_type: 'Empresa',
        origin_type: origin,
        eventCallback,
      })
    }),
  loginFallido: (reason) =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Usuarios Empresa',
        eventAction: 'Login',
        eventLabel: `Login fallido-${reason}`,
        eventCallback,
      })
    }),
  clickLoginGoogle: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Usuarios Empresa',
        eventAction: 'Login',
        eventLabel: 'CTA Ingresar con Google',
        eventCallback,
      })
    }),
  clickRegistro: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Usuarios Empresa',
        eventAction: 'Login',
        eventLabel: 'Click a Registrate',
        eventCallback,
      })
    }),
  clickSoyPostulante: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Usuarios Empresa',
        eventAction: 'Login',
        eventLabel: 'Click a Soy postulante',
        eventCallback,
      })
    }),
  clickCambiarPassword: () =>
    new Promise((eventCallback) => {
      TagManager.Push({
        event: 'trackEvent',
        eventCategory: 'Usuarios Empresa',
        eventAction: 'Recupero de contraseña',
        eventLabel: 'Click a Olvide mi contraseña',
        eventCallback,
      })
    }),
  contentGroup: () => {
    return TagManager.Push({
      event: 'track_content_group',
      content_group: 'Ingreso',
    })
  },
  loginGoogleSinRegistroPrevio: () => {
    return TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Usuarios Empresa',
      eventAction: 'Login',
      eventLabel: 'CTA Ingresar con Google',
    })
  },
}
